import { Button, Col, Divider, Flex, Input, InputRef, Popconfirm, Row, Space, Spin, Table, Tag, notification } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import CustomButton from '../../components/Buttons/Button'
import AddOboAccount from '../AddOboAccount/addOboAccount';
import { useDispatch, useSelector } from 'react-redux';
import { deleteOboConfig, fetchBuAndClientDetails_Opportunity, fetchOboConfigData } from '../../store/reducers/orderDashboardSlice';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import { ColumnType, FilterConfirmProps, TablePaginationConfig } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

interface OboAccountConfigData {
    clientName: string;
    accountOwner: string;

}
type DataIndex = keyof OboAccountConfigData;

const  OboAccountConfig=() =>{

    const dispatch = useDispatch();
    const orderDashboardData = useSelector((state: any) => state.orderDashboard);
    const [configModalVisible, setConfigModalVisible] = React.useState(false);
    const [configType, setConfigType] = React.useState('');
    const [clientData, setClientData] = React.useState<any>([]);
    const [selectedClient, setSelectedClient] = React.useState({});

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [pageNo, setPageNo] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
      ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
      };
      const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
              style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  setSelectedKeys([]);
                  handleSearch([], confirm, dataIndex);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
              {/* <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({ closeDropdown: false });
                  setSearchText((selectedKeys as string[])[0]);
                  setSearchedColumn(dataIndex);
                }}
              >
                Filter
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  close();
                }}
              >
                close
              </Button> */}
            </Space>
          </div>
        ),
        filterIcon: (filtered: boolean) => (
          <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
        record[dataIndex] && record[dataIndex]
            .toString()
            .toLowerCase()
            .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      });
    

    useEffect(() => {
        
        if(orderDashboardData.opportunity_clientEntityList===null || orderDashboardData.opportunity_clientEntityList.length===0){
            dispatch(fetchBuAndClientDetails_Opportunity()).then(
                (res: any) => {
                    if (res.type === 'orderDashboard/fetchBuAndClientDetails_Opportunity/fulfilled') {
                        console.log('res',res);
                        fetchOboConfig();
                    }
                    else{
                        rejectedApiMessage(res.payload);
                        fetchOboConfig();
                    }
                }
            
            );
        }
        else{
          fetchOboConfig();
        }
    },[]);

    const transformData = (data: any) => {

      const transformedData:any=[];

      Object.keys(data).map((key,index)=>{
          transformedData.push({
              clientName:key,
              accountOwner: data[key].map((item:any)=>item.employeeDetails.email).join(','),
          })
      })

      return transformedData;
    }

    const handleConfigModal = (visible: boolean, type: string,selectedClient?:any) => {
        if(visible && type === 'add' ){
            setConfigModalVisible(visible);
            setConfigType(type);
            setSelectedClient({});
        }else if(visible && type === 'edit'){
            setConfigModalVisible(visible);
            setConfigType(type);
            setSelectedClient(selectedClient)

         }
         else{
            setConfigModalVisible(visible);
            setConfigType('');
            setSelectedClient({});
         }
    }

    const columns = [
        {
          title: 'Client Name',
          dataIndex: 'clientName',
          key: 'clientName',
            ...getColumnSearchProps('clientName'),
        },
        {
          title: 'Account Owners',
          dataIndex: 'accountOwner',
          key: 'accountOwner',
          ...getColumnSearchProps('accountOwner'),
          width: '50%',
          render : (text:any,record: any) => {
                return (text.split(',').map((item:any,index:number)=>
                <Tag key={index} style={{margin:'5px'}}>{item}</Tag>) )

          }
        },
        {
          title: 'Action',
          key: 'action',
          render: (text: any, record: any) => (
            <div>
              <a className='maplink' onClick={()=>handleConfigModal(true,"edit",record)}>Edit</a>
              <br/>
              <Popconfirm title="Are you sure, you want to delete？" okText="Yes" cancelText="No" onConfirm={()=>handleDelete(record)}>
                <a className='maplink'>Delete</a>
              </Popconfirm>
            </div>
          ),
        },
      ];

    const handleDelete = (record:any) => {
        dispatch(deleteOboConfig({"clientName": encodeURIComponent( record.clientName)})).then(
            (res: any) => {
                if (res.type === 'orderDashboard/deleteOboConfig/fulfilled') {
                    fetchOboConfig();
                    notification.success({
                        message: 'Success',
                        description: `Configuration for ${record.clientName} deleted successfully`,
                    });
                }
                else{
                    rejectedApiMessage(res.payload);
                }
            }
        );
      }

    const handlesubmit = () => {
        handleConfigModal(false,"");
        fetchOboConfig();

    }
    const fetchOboConfig = () => {
        dispatch(fetchOboConfigData()).then(
            (res: any) => {
                if (res.type === 'orderDashboard/fetchOboConfigData/fulfilled') {
                    setClientData(res.payload);
                    setPageNo(0);
                }
                else{
                    rejectedApiMessage(res.payload);
                }
            }
        );
            
    }
    const handleTableChange = (pagination: TablePaginationConfig) => {
        const { current, pageSize } = pagination;
        setPageNo(current ? current - 1 : 0);
        setPageSize(pageSize || 10);
      };
  return (
    <Spin spinning={orderDashboardData.loading}>
        <div style={{display:'flex', justifyContent:'end'}}>
            <CustomButton type='submit' label='Add Config' key="add-client-name" onClick={()=>handleConfigModal(true,"add") } ></CustomButton>
        </div>
        <Divider orientation='center'>Client Name with Account Owners</Divider>
        <div>
            <Table columns={columns} dataSource={transformData(clientData)}
            pagination={{
                current: pageNo + 1,
                pageSize,
                total: transformData(clientData).length ||0,
              showSizeChanger: false,
              }}
              onChange={handleTableChange} />
        </div>

        <AddOboAccount visible={configModalVisible} configType={configType} selectedClient={selectedClient} onCancel={()=>handleConfigModal(false,"")} onSubmit= {()=>handlesubmit()} />
    </Spin>
  )
}

export default OboAccountConfig;